import React from 'react';
import Classnames from 'classnames';

import './style.css';

export default class EditableName extends React.PureComponent {
  state = {
    editing: false,
  };

  render() {
    const { value, onChange, version, side, TEXT, onBlur } = this.props;
    const { editing } = this.state;

    const displayName = this.props.displayName || 
      (<span className={Classnames('heading', { empty: !value, [version]: true })}>
        {value}
      </span>)

    return (
      <div className={Classnames("editable-name", side+version)}>
        {!editing
          ? displayName
          : <input
              ref="input"
              className={Classnames('heading', { empty: !value })}
              value={value || ''}
              onChange={event => onChange(event.target.value)}
              disabled={!editing}
              onBlur={() => {
                this.setState({ editing: false }); 
                if(typeof onBlur !== 'undefined' && typeof onBlur === 'function'){
                  onBlur();
                }
              }}
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  event.target.blur();
                }
              }}
            />}
        <span
          className={Classnames("edit-action", { editing, [version]: true })}
          onClick={() => {
            this.setState({ editing: true }, () => {
              this.refs.input.focus();
              this.refs.input.select && this.refs.input.select();
            });
          }}>
          <span className="not-mobile">
            {version === "name" 
              ? TEXT.editNameLabel 
              : version === "email" 
                ? "Edit e-mail" : ""}
          </span>
          <span className="mobile">
            {TEXT.editNameMobileLabel}
          </span>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditableName/index.js